module.exports = __webpack_public_path__ + "media/images/amenities_icons/3d_printer-25534eb4feebb6951de8ea9e71cc6077.svg";